import { useEffect, useState, useMemo } from 'react';
import CommonService from '../services/common.service';

/**
 * UI listing type → `master_facility_type.infrastructure_type` (API filter).
 * - Property (card)     → 1
 * - Machinery / Asset  → 2
 */
export const LISTING_TYPE_TO_INFRASTRUCTURE = {
  property: 1,
  machinery: 2,
};

/**
 * Fetches `/master/facility-types` with optional `infrastructureType` filter.
 * @param {string|null|undefined} listingType - 'property' | 'machinery' | other
 */
export function useMasterFacilityTypes(listingType) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const infrastructureType = useMemo(() => {
    if (!listingType) return undefined;
    return LISTING_TYPE_TO_INFRASTRUCTURE[listingType] ?? undefined;
  }, [listingType]);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      setError(null);
      try {
        const params =
          infrastructureType != null && !Number.isNaN(infrastructureType)
            ? { infrastructureType }
            : {};
        const response = await CommonService.get('/master/facility-types', params);
        if (cancelled) return;
        const raw = response?.data;
        const rows = Array.isArray(raw) ? raw : [];
        setList(rows);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setList([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [infrastructureType]);

  return { list, loading, error, infrastructureType };
}
